/* eslint-disable import/prefer-default-export */
export const revealPassword = (e) => {
  let inputGroup = e.currentTarget.parentNode;

  if (inputGroup && inputGroup?.className.indexOf('form-group') === -1) {
    inputGroup = e.currentTarget.parentNode.parentNode;
  }
  const input = inputGroup.childNodes[0];
  if (input.type === 'password') {
    input.type = 'text';
    e.target.className = e.target.className.replace('open', 'close');
  } else if (input.type === 'text') {
    input.type = 'password';
    e.target.className = e.target.className.replace('close', 'open');
    e.target.style.top = '';
  }
};
